<template>
    <section id="availability">
        <div class="flex gap-4 lg:flex-row flex-col scroll-mt-24">
            <div class="flex-1 space-y-2">
                <!-- Category -->
                <ProductCategory :value="item.property?.category" />

                <!-- Name -->
                <h1 class="text-2xl font-semibold">{{ item.name }}</h1>

                <!-- Location -->
                <ProductLocation :fullLocation="item.fullLocation" />

            </div>
            <div>
                <ProductAvgReview :avgScore="item.avgScore" variant="large" v-if="item.avgScore" />
            </div>
        </div>
        <div class="flex flex-wrap gap-4 mt-4">
            <template v-if="item.max_occupancy">
                <div class="border border-gray-300 rounded-2xl py-4 px-5 space-y-5">
                    <i class="icon-User-Groups size-9 rounded-full bg-gray-100 text-gray-800 flex items-center text-xl justify-center"></i>
                    <div class="flex justify-between gap-4">
                        <span>{{ $t('Max. number of people') }}</span>
                        <span class="font-semibold">{{ item.max_occupancy }}</span>
                    </div>
                </div>
            </template>
            <template v-if="item.properties?.count_bedrooms">
                <div class="border border-gray-300 rounded-2xl py-4 px-5 space-y-5">
                    <i class="icon-Bedroom size-9 rounded-full bg-gray-100 text-gray-800 flex items-center text-xl justify-center"></i>
                    <div class="flex justify-between gap-4">
                        <span>{{ $t('Number of bedrooms') }}</span>
                        <span class="font-semibold">{{ item.properties?.count_bedrooms }}</span>
                    </div>
                </div>
            </template>
            <template v-if="item.properties?.pets_not_allowed">
                <div class="border border-gray-300 rounded-2xl py-4 px-5 space-y-5">
                    <i class="icon-Dog size-9 rounded-full bg-gray-100 text-gray-800 flex items-center text-xl justify-center"></i>
                    <div class="flex justify-between gap-4">
                        <span>{{ $t('Pets') }}</span>
                        <span class="font-semibold">{{ $t('No') }}</span>
                    </div>
                </div>
            </template>
            <template v-if="item.properties?.pets_allowed">
                <div class="border border-gray-300 rounded-2xl py-4 px-5 space-y-5">
                    <i class="icon-Dog size-9 rounded-full bg-gray-100 text-gray-800 flex items-center text-xl justify-center"></i>
                    <div class="flex justify-between gap-4">
                        <span>{{ $t('Pets') }}</span>
                        <span class="font-semibold">{{ $t('Yes') }}</span>
                    </div>
                </div>
            </template>
        </div>
    </section>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        required: true
    }
})
</script>
